__turbopack_context__.v({
  "logoWithLabel": "Logo-module-scss-module__NQAhCa__logoWithLabel",
  "wrapper": "Logo-module-scss-module__NQAhCa__wrapper",
});
